export default __webpack_public_path__ + "static/media/cover-clerk@2x.ff295dae.png";